import { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

type TPgSectionHeaderProps = {
	/** Last breadcrumb item (the tab). */
	title: string;
	/** Intermediate breadcrumb item, e.g. `Settings`. */
	group?: string;
	/** Buttons on the right. */
	children?: ReactNode;
};

/** `Finance & VAT / Payment Gateway / … / <Tab>` line with actions, as on the other CC pages. */
export const PgSectionHeader: FC<TPgSectionHeaderProps> = ({ title, group, children }) => (
	<Box
		sx={{
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: 1,
			minHeight: '32px',
		}}
	>
		<Typography variant="body1" color="primary">
			Finance &amp; VAT / Payment Gateway / {group ? `${group} / ` : ''}
			<b>{title}</b>
		</Typography>
		{children && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{children}</Box>}
	</Box>
);
